var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaidInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13380",
    width: 240,
    height: 240,
    rx: 8,
    transform: "translate(1132 178)",
    fill: "#2e8b57",
    opacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paid_invoice",
    transform: "translate(-1132 -178)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9055",
    transform: "translate(981.125 -43.811) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13379",
    width: 350,
    height: 69,
    rx: 8,
    transform: "translate(257.174 -25)",
    fill: "#2e8b57"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Content_signup",
    transform: "translate(399.174 21)",
    fill: "#fff",
    fontSize: 36,
    fontFamily: "Tajawal-Bold, Tajawal",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Paid"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidInvoice);
export default __webpack_public_path__ + "static/media/paid_invoice.d89f0a56b340efa67c85406eeb927447.svg";
export { ForwardRef as ReactComponent };